/*
 * Access denied / permission error screen.
 * Shows message bar, access denied content, and on mobile the email report form.
 */

import React from "react";
import { FaBan } from "react-icons/fa";
import i18n from "../../../i18n/i18n.js";
import MessageBar from "../MessageBar.jsx";
import MobileEmailReport from "./MobileEmailReport.jsx";

export default function AccessDeniedScreen({
  message,
  getMessageBarClass,
  isMobile,
  permissionError,
  activeUserEmail,
  // Mobile report state & handler
  reportType,
  setReportType,
  reportAdditionalInfo,
  setReportAdditionalInfo,
  reportingEmail,
  onEmailReport,
}) {
  return (
    <div className="p-4 max-w-md min-h-[500px] flex flex-col gap-4">
      {message && (
        <MessageBar message={message} getMessageBarClass={getMessageBarClass} />
      )}

      {/* Access Denied Message */}
      <div className="flex flex-col items-center justify-center text-center py-4">
        <FaBan className="w-16 h-16 text-red-500 mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {i18n.t("common.accessDenied")}
        </h2>
        <p className="text-gray-600 mb-4">{i18n.t("messages.accessDenied")}</p>
        {isMobile && (
          <p className="text-sm text-blue-600 font-medium mt-2">
            {i18n.t("messages.mobileCanStillReport")}
          </p>
        )}
        <div className="text-sm text-gray-500">
          <p>
            {i18n.t("common.user")}: {activeUserEmail}
          </p>
          {permissionError === "user_not_found" && (
            <p>
              {i18n.t("common.status")}: {i18n.t("messages.userNotFound")}
            </p>
          )}
        </div>
      </div>

      {/* Mobile Email Report - only on mobile */}
      {isMobile && (
        <MobileEmailReport
          reportType={reportType}
          setReportType={setReportType}
          reportAdditionalInfo={reportAdditionalInfo}
          setReportAdditionalInfo={setReportAdditionalInfo}
          reportingEmail={reportingEmail}
          onReport={onEmailReport}
        />
      )}
    </div>
  );
}
